import SimpleSlider from './SimpleSlider'

export default SimpleSlider